import { NavLink } from 'react-router-dom';
import logo from '../assets/Logo-realestate.png';
import lurie from '../assets/lurie-city.png';
import nar from '../assets/nar-black.png';
import eho from '../assets/eho.png';
import '../styles/Footer.scss';

const Footer = () => {
  return (
    <footer className='footer'>
      <div className='footer-main'>
        <div className='footer-logos'>
          <img loading='eager' src={logo} className='footer-logo' alt='Lily Lai Real Estate' />
          <a href='https://luriegroup.com/agent/lily-lai' target='_blank' rel='noreferrer' onClick={() => { if (typeof window.gtag === 'function') window.gtag('event', 'footer_compass_click'); }}>
            <img loading='eager' src={lurie} className='footer-compass' alt='The Lurie Group at City Real Estate' />
          </a>
        </div>

        <div className='footer-contact'>
          <a href='mailto:lily@lilylaisf.com' className='footer-info' onClick={() => { if (typeof window.gtag === 'function') window.gtag('event', 'footer_email_click'); }}>lily@lilylaisf.com</a>
          <a href='tel:4157282623' className='footer-info' onClick={() => { if (typeof window.gtag === 'function') window.gtag('event', 'footer_phone_click'); }}>415.728.2623</a>
          <span className='footer-info'>DRE #02123349</span>
          <span className='footer-info'>629 Divisadero St, San Francisco, CA 94117</span>
        </div>

        <div className='footer-social'>
          <a href='https://www.instagram.com/lily_lai__/' target='_blank' rel='noreferrer' aria-label='Instagram' onClick={() => { if (typeof window.gtag === 'function') window.gtag('event', 'footer_social_click', { platform: 'instagram' }); }}>
            <img loading='eager' src='https://img.icons8.com/sf-ultralight/100/instagram-new.png' alt='Instagram' />
          </a>
          <a href='https://www.facebook.com/lily.lai.7370' target='_blank' rel='noreferrer' aria-label='Facebook' onClick={() => { if (typeof window.gtag === 'function') window.gtag('event', 'footer_social_click', { platform: 'facebook' }); }}>
            <img loading='eager' src='https://img.icons8.com/sf-ultralight/100/facebook.png' alt='Facebook' />
          </a>
          <a href='https://www.linkedin.com/in/lily-lai-03382a87/' target='_blank' rel='noreferrer' aria-label='LinkedIn' onClick={() => { if (typeof window.gtag === 'function') window.gtag('event', 'footer_social_click', { platform: 'linkedin' }); }}>
            <img loading='eager' src='https://img.icons8.com/sf-ultralight/100/linkedin.png' alt='LinkedIn' />
          </a>
        </div>
      </div>

      <div className='footer-divider' />

      <div className='footer-disclaimer'>
        <div className='footer-badges'>
          <img loading='eager' src={nar} alt='NAR' title='NAR' />
          <img loading='eager' src={eho} alt='Equal Housing Opportunity' title='Equal Housing Opportunity' />
        </div>
        <p className='footer-copy'>
          Copyright © {new Date().getFullYear()} Lily Lai Real Estate&ensp;|&ensp;All Rights Reserved&ensp;|&ensp;
          <NavLink to='/privacypolicy'>Privacy Policy</NavLink>
        </p>
      </div>
    </footer>
  );
};

export default Footer;
